/*
 |------------------------------------------------------------------------------
 | Add API data transform
 |------------------------------------------------------------------------------
 |
 | This transform will call a provided API endpoint and add its data to
 | a specific param inside containers state.
 |
 */

import { pickBy, debounce, includes } from 'lodash';

export default ({
	// This key we add to the state.
	stateKey,
	// The endpoint that is called.
	endpoint,
	// The part of the response to use.
	responseKey,
	// We can provide keys to omit
	// so we don't have to send the entire state as parameters.
	omitKeys = []
}) => {
	return ({ currentState, options }) =>
		new Promise(async (resolve, reject) => {
			if (!options.refresh) {
				resolve(null);

				return null;
			}

			try {
				const data = await endpoint(
					pickBy(currentState, (_, key) => !includes(omitKeys, key))
				);

				resolve({
					[stateKey]: (responseKey ? data[responseKey] : data) || null
				});
			} catch (err) {
				reject(err);
			}
		});
};
